import copy from 'copy-to-clipboard';

export default class CopyLink {
	constructor(el) {
        this.el = el;

		if(!this.el) {
			return;
		}

		let copyTimer = null;

		this.el.addEventListener('click', (e) => {
			const button = e.currentTarget;
			const tooltip = button.querySelector('.tooltip');
			const text = button.dataset.copyToClipboard;

			console.log(button)

			clearTimeout(copyTimer);
			copy(text);
			tooltip.innerText = 'URL gekopieerd';

			copyTimer = setTimeout(() => {
				tooltip.innerText = 'Klik om URL te kopiëren';
			}, 3000);
		});
	}
}
